import { Routes } from "@angular/router";

export const ARTIFACTS_CHILD_ROUTES: Routes = [
  {
    path: 'prefabs',
    loadComponent: () => import('../prefabs/prefabs.component').then((c) => c.PrefabsComponent)
  },
  {
    path: 'themes',
    loadComponent: () => import('../themes/themes.component').then((c) => c.ThemesComponent)
  },
  {
    path: 'project-shells',
    loadComponent: () => import('../project-shells/project-shells.component').then((c) => c.ProjectShellsComponent)
  },
  {
    path: 'template-bundles',
    loadComponent: () => import('../template-bundles/template-bundles.component').then((c) => c.TemplateBundlesComponent)
  },
  {
    path: 'prefabs/project-prefab',
    loadComponent: () => import('../teams-prefabs/teams-prefabs.component').then((c) => c.TeamsPrefabsComponent)
  },
  {
    path: 'prefabs/team-prefab',
    loadComponent: () => import('../teams-prefabs/teams-prefabs.component').then((c) => c.TeamsPrefabsComponent)
  },
  {
    path: 'prefabs/marketplace-prefab',
    loadComponent: () => import('../teams-prefabs/teams-prefabs.component').then((c) => c.TeamsPrefabsComponent)
  },
  {
    path: 'other-artifacts/project-shells',
    loadComponent: () => import('../other-artifacts/other-artifacts.component').then((c) => c.OtherArtifactsComponent)
  },
  {
    path: 'other-artifacts/template-bundles',
    loadComponent: () => import('../other-artifacts/other-artifacts.component').then((c) => c.OtherArtifactsComponent)
  },
  {
    path: 'other-artifacts/themes',
    loadComponent: () => import('../other-artifacts/other-artifacts.component').then((c) => c.OtherArtifactsComponent)
  }
];